import React, { useState, useEffect, useRef } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fermer le menu mobile en cliquant à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen && 
        headerRef.current && 
        !headerRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
        setIsServicesDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const servicesList = [
    "Tonte de pelouse",
    "Taille de haie", 
    "Désherbage",
    "Ramassage des feuilles",
    "Débroussaillage",
    "Petit élagage"
  ];

  const handleNavClick = (section) => {
    const element = document.getElementById(section);
    if (element) {
      const headerHeight = headerRef.current?.offsetHeight || 80;
      const elementPosition = element.offsetTop - headerHeight + 1;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
    setIsServicesDropdownOpen(false);
  };

  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
  };

  const handleServiceClick = (serviceId) => {
    handleNavClick(serviceId);
    setIsServicesDropdownOpen(false);
  };

  return (
    <header ref={headerRef} className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <a href="/" className="logo">
        <div className="logo-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>
            <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
          </svg>
        </div>
        <h1>Pochard Espaces Verts</h1>
      </a>
      
      <nav>
        <ul>
          <li onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Accueil</li>
          <li 
            className={`dropdown ${isServicesDropdownOpen ? 'active' : ''}`}
            onMouseEnter={() => setIsServicesDropdownOpen(true)}
            onMouseLeave={() => setIsServicesDropdownOpen(false)}
          >
            <span onClick={toggleServicesDropdown}>Services</span>
            <ul className="dropdown-menu">
              {servicesList.map((service, index) => (
                <li key={index} onClick={() => handleNavClick(`service-${index}`)}>
                  {service}
                </li>
              ))}
            </ul>
          </li>
          <li onClick={() => handleNavClick('sap')}>Crédit d'impôt</li>
          <li onClick={() => handleNavClick('infos')}>FAQ</li>
          <li onClick={() => handleNavClick('contact')}>Contact</li>
        </ul>
      </nav>
      
        
      <button 
        className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      
      {/* Menu mobile */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <ul>
          <li onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setIsMobileMenuOpen(false); setIsServicesDropdownOpen(false); }}>Accueil</li>
          <li className={`mobile-dropdown ${isServicesDropdownOpen ? 'active' : ''}`} onClick={toggleServicesDropdown}>
            <span>Services</span>
            <ul className="mobile-dropdown-menu">
              {servicesList.map((service, index) => (
                <li key={index} onClick={() => handleServiceClick(`service-${index}`)}>
                  {service}
                </li>
              ))}
            </ul>
          </li>
          <li onClick={() => handleNavClick('sap')}>Crédit d'impôt</li>
          <li onClick={() => handleNavClick('infos')}>FAQ</li>
          <li onClick={() => handleNavClick('contact')}>Contact</li>
        </ul>
      </div>
    </header>
  );
};

export default Header;